import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { SiteProvider } from "./context/SiteContext";
import { Navbar } from "./components/site/Navbar";
import { Footer } from "./components/site/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";
import { NewsList, NewsDetail } from "./pages/News";
import Players from "./pages/Players";
import Achievements from "./pages/Achievements";
import Gallery from "./pages/Gallery";
import OfficeBearers from "./pages/OfficeBearers";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

const TITLES = { "/": "Home", "/about": "About", "/events": "Events", "/news": "News", "/players": "Players", "/achievements": "Achievements", "/gallery": "Gallery", "/office-bearers": "Office Bearers", "/contact": "Contact" };

const PublicLayout = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${TITLES[pathname] || "TDBA"} | Thanjavur District Badminton Association`;
  }, [pathname]);
  return (
    <>
      <Navbar />
      <main><Outlet /></main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <SiteProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/:id" element={<EventDetail />} />
            <Route path="/news" element={<NewsList />} />
            <Route path="/news/:id" element={<NewsDetail />} />
            <Route path="/players" element={<Players />} />
            <Route path="/achievements" element={<Achievements />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/office-bearers" element={<OfficeBearers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </SiteProvider>
  );
}

export default App;
